import { schema } from 'normalizr';

const auctionSchema = new schema.Entity('auction');

export default auctionSchema;
